// extracted by css-extract-rspack-plugin
export default {"body":"xBZMC","content":"EqxRp","tabsList":"oD9bn","tabPanel":"f8tuB"};